import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { CacheService } from "../services/cache.service";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _cacheService: CacheService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const jwt = this._cacheService.get("jwt");
    // If we have a JWT pass on the request with the Authorization header.
    if (jwt) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`,
        },
      });

      return next.handle(authReq);
      // If we dont have a JWT and the request is for the app init domains call then pass it on to the next handler.
    } else if (req.url.includes("/api/domains/info")) {
      return next.handle(req);
    }

    return next.handle(req);
  }
}
